import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const loadingSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    setLoader: (state, action) => {
      const { name, value } = action.payload;
      state[name] = value; 
    },
    resetLoader: () => initialState, 
  },
});

export const { setLoader, resetLoader } = loadingSlice.actions;
export default loadingSlice.reducer;
